/**
 * Material UI tabs styled to Ant Design look and feel
 * adopted from one of Material UI example in docs
 *
 * Reason for using Material Design Tab instead of Ant Design Tab directly
 * is because Material Design tab style are self contained while Ant Design
 * Tab style cannot be imported without polluting a lot of global styles.
 */
import { styled } from '@mui/system'
import Tabs from '@mui/material/Tabs'
import Tab, { TabProps } from '@mui/material/Tab'

import tailwind from '_/tailwind.config'

/**
 * Material UI Ant Design styled tabs container
 *
 * Usage:
 * ```
 * <AntTabs value={ value } onChange={ handleChange } aria-label='ant example'>
 *   <AntTab label='Tab 1' />
 *   <AntTab label='Tab 2' />
 *   <AntTab label='Tab 3' />
 * </AntTabs>
 * ```
 */
export const AntTabs = Tabs

/**
 * Material UI Ant Design styled tab component
 */
export const AntTab = styled((props: TabProps) => (
  <Tab disableRipple {...props} />
))(({ theme }) => ({
  textTransform: 'none',
  marginRight: theme.spacing(1),
  color: tailwind.theme.colors.gray[300],
  ':hover': {
    color: theme.palette.primary.main
  }
}))
